export default function () {
  return {
    user: {},
    pageTitle: '',
    currentWeekPerProgram: {
      '1': 0,
      '1_1': 0,
      '1_2': 0,
      '1_3': 0,
      '1_4': 0,
      '2': 0,
      '2_1': 0,
      '2_2': 0,
      '2_3': 0,
      '2_4': 0,
    },
    paymentsEnabled: false,
  }
}
